export default __webpack_public_path__ + "static/media/header-visu1.c6d1ba9a.jpg";